import React, { useState } from "react";
import API_URL from "../apiConfig";

export default function UpdatePasswordModal({ show, onClose, userType, user, token, onUpdated }) {
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  if (!show || !user) return null;

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMsg("");
    const url =
      userType === "student"
        ? `${API_URL}/api/students/${user.id}/update-password`
        : `${API_URL}/api/staff/${user.id}/update-password`;
    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (res.ok && !data.error) {
        setMsg("Password updated successfully!");
        onUpdated && onUpdated();
        setPassword("");
        setTimeout(onClose, 1200);
      } else {
        setMsg(data.error || "Error updating password.");
      }
    } catch {
      setMsg("Server error.");
    }
    setLoading(false);
  };

  return (
    <div className="user-modal">
      <form className="user-form" onSubmit={handleSubmit}>
        <h3>
          Update Password for {user.name || user.full_name || user.email || ""}
        </h3>
        <div className="user-form-group">
          <label>New Password</label>
          <input
            type="password"
            value={password}
            minLength={6}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="new-password"
            placeholder="Enter new password"
          />
        </div>
        {msg && (
          <div
            className={`user-form-msg ${
              msg.toLowerCase().includes("success") ? "success" : "error"
            }`}
          >
            {msg}
          </div>
        )}
        <div className="user-form-actions">
          <button type="submit" className="user-btn" disabled={loading || !password}>
            {loading ? "Updating..." : "Update"}
          </button>
          <button type="button" className="user-btn user-btn-cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}